module.exports = __webpack_public_path__ + "img/9788932908724.b0ee18bd.jpg";